// src/components/Footer.js
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full py-4 bg-[black] text-center">
      <h1 className="text-white">All Rights Reserved @Kaizen Global 2024</h1>
      <Link to="/privacy-policy" className="text-[#ba56d4] underline mt-2">
        Privacy Policy
      </Link>
    </footer>
  );
}
